
document.addEventListener("DOMContentLoaded", function() {

  const gallery = document.querySelector(".gallery-page");
  if (!gallery) return;

  const buttons = gallery.querySelectorAll(".filter-btn");
  const items = gallery.querySelectorAll(".gallery-item");

  // ===== Filter Buttons =====
  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const filterTag = btn.dataset.filter.toLowerCase();

      items.forEach(item => {
        const tags = (item.dataset.tags || "").toLowerCase();
        if (filterTag === "all" || tags.includes(filterTag)) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
    });
  });


  // ===== Lightbox =====
  const lightboxOverlay = document.createElement("div");
  lightboxOverlay.className = "lightbox-overlay";

  // Create lightbox image
  const lightboxImg = document.createElement("img");

  // Caption
  const lightboxCaption = document.createElement("div");
  lightboxCaption.className = "lightbox-caption";

  // Arrows
  const arrowPrev = document.createElement("div");
  arrowPrev.className = "lightbox-arrow prev";
  arrowPrev.innerHTML = "&#10094;"; // left caret

  const arrowNext = document.createElement("div");
  arrowNext.className = "lightbox-arrow next";
  arrowNext.innerHTML = "&#10095;"; // right caret

  // Append everything once — DO NOT overwrite later
  lightboxOverlay.appendChild(lightboxImg);
  lightboxOverlay.appendChild(lightboxCaption);
  lightboxOverlay.appendChild(arrowPrev);
  lightboxOverlay.appendChild(arrowNext);
  document.body.appendChild(lightboxOverlay);

  let currentIndex = 0;
  function getVisibleGalleryLinks() {
  return Array.from(
    gallery.querySelectorAll(".gallery-item:not(.hidden) .lightbox-link")
  );
}

  // Show lightbox at index
  function showLightbox(index) {
    const visibleLinks = getVisibleGalleryLinks();
    const link = visibleLinks[index];
    const item = link.closest(".gallery-item");
    lightboxImg.src = link.href;

    const captionEl = item.querySelector(".gallery-caption");
    lightboxCaption.textContent = captionEl ? captionEl.textContent : "";

    lightboxOverlay.classList.add("visible");
    currentIndex = index;
  }

  // Open lightbox on click
gallery.querySelectorAll(".lightbox-link").forEach(link => {
  link.addEventListener("click", e => {
    e.preventDefault();

    const visibleLinks = getVisibleGalleryLinks();
    currentIndex = visibleLinks.indexOf(link);

    showLightbox(currentIndex);
  });
});


  // Close lightbox when clicking outside image
  lightboxOverlay.addEventListener("click", e => {
    if (e.target === lightboxOverlay) {
      lightboxOverlay.classList.remove("visible");
      lightboxImg.src = "";
      lightboxCaption.textContent = "";
    }
  });

  // Arrow click navigation
  arrowPrev.addEventListener("click", e => {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + getVisibleGalleryLinks().length) % getVisibleGalleryLinks().length;
    showLightbox(currentIndex);
  });

  arrowNext.addEventListener("click", e => {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % getVisibleGalleryLinks().length;
    showLightbox(currentIndex);
  });

  // Keyboard navigation
  document.addEventListener("keydown", e => {
    if (!lightboxOverlay.classList.contains("visible")) return;

    if (e.key === "Escape") {
      lightboxOverlay.classList.remove("visible");
      lightboxImg.src = "";
      lightboxCaption.textContent = "";
    }
    if (e.key === "ArrowRight") {
      currentIndex = (currentIndex + 1) % getVisibleGalleryLinks().length;
      showLightbox(currentIndex);
    }
    if (e.key === "ArrowLeft") {
      currentIndex = (currentIndex - 1 + getVisibleGalleryLinks().length) % getVisibleGalleryLinks().length;
      showLightbox(currentIndex);
    }
  });

  // ===== Touch / Swipe Support =====
  let touchStartX = 0;
  let touchEndX = 0;

  lightboxOverlay.addEventListener("touchstart", e => {
    touchStartX = e.changedTouches[0].screenX;
  });

  lightboxOverlay.addEventListener("touchend", e => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeDistance = touchEndX - touchStartX;
    if (Math.abs(swipeDistance) < 50) return; // ignore tiny swipes

    if (swipeDistance > 0) {
      // swipe right -> previous
      currentIndex = (currentIndex - 1 + getVisibleGalleryLinks().length) % getVisibleGalleryLinks().length;
      showLightbox(currentIndex);
    } else {
      // swipe left -> next
      const visibleLinks = getVisibleGalleryLinks();
      currentIndex = (currentIndex + 1) % visibleLinks.length;

      showLightbox(currentIndex);
    }
  }

});
